import { render } from "./AddonPlays.vue?vue&type=template&id=64665978&scoped=true"
import script from "./AddonPlays.vue?vue&type=script&lang=js"
export * from "./AddonPlays.vue?vue&type=script&lang=js"

import "./AddonPlays.vue?vue&type=style&index=0&id=64665978&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64665978"]])

export default __exports__